var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFixar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f7:pin-slash-fill",
    clipPath: "url(#clip0_9022_14281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6333 1.55371H4.36085H3.88395C3.43671 1.55371 3.13281 1.9082 3.13281 2.31068C3.13281 2.58107 3.26482 2.87545 3.58005 3.11565L4.97346 4.17293C5.08822 4.2511 5.11113 4.32928 5.1227 4.46138L5.3132 5.90361L5.30136 5.89121L5.39864 6.65412C5.43312 6.90025 5.35283 6.99649 5.23807 7.12884L3.48337 9.12318C3.31714 9.30946 3.24252 9.48954 3.24252 9.74187C3.24252 10.1443 3.52352 10.4088 3.92494 10.4088H5.38055H6.9871V13.4965C6.9871 14.4099 7.35405 15.1787 7.49196 15.1787C7.49279 15.1787 7.49362 15.1787 7.49446 15.1786C7.49533 15.1786 7.4962 15.1785 7.49708 15.1784C7.49881 15.1786 7.50052 15.1787 7.50219 15.1787C7.6401 15.1787 8.00705 14.4099 8.00705 13.4965V10.4088H9.6136H11.0692C11.4706 10.4088 11.7516 10.1443 11.7516 9.74187C11.7516 9.48954 11.677 9.30946 11.5108 9.12318L9.75608 7.12884C9.64132 6.99649 9.56103 6.90025 9.59551 6.65412L9.69279 5.89121L9.68095 5.90361L9.87145 4.46138C9.88303 4.32928 9.90593 4.2511 10.0207 4.17293L11.4141 3.11565C11.7293 2.87545 11.8613 2.58107 11.8613 2.31068C11.8613 1.9082 11.5574 1.55371 11.1102 1.55371H10.6333Z",
    fill: "#006560"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9022_14281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixar);
export default __webpack_public_path__ + "static/media/Fixar.4184769499013608b27cdefc69879275.svg";
export { ForwardRef as ReactComponent };